import { useContext } from 'react';
import { NavActiveContext } from './FmNavActiveContext.types';
import type { FmNavActiveContextValue } from './FmNavActiveContext.types';

/**
 * Hook: access the current active navigation state.
 * Throws if not inside a FmNavActiveProvider.
 */
export function useFmNavActive(): FmNavActiveContextValue {
  const ctx = useContext(NavActiveContext);
  if (!ctx) {
    throw new Error(
      'useFmNavActive must be called within FmNavActiveProvider',
    );
  }
  return ctx;
}
